<template>
    <div>
        <el-breadcrumb
            v-if="hasRoleToReadLogs"
            style="float: right"
            separator-class="el-icon-arrow-right"
        >
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
            <el-breadcrumb-item> {{$t('entities.tournament.plural')}} </el-breadcrumb-item>
        </el-breadcrumb>

        <h2 class="page-title">{{$t('entities.tournament.plural')}}</h2>

        <el-row :gutter="20">
            <el-col :xs="24" :md="8">
                <el-form @submit.native.prevent class="search" :inline="true">
                    <el-form-item>
                        <el-input v-model="pager.search" :placeholder="$t('table.search')">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <el-col class="button-group" :xs="24" :md="16">
                <el-button
                    v-if="hasRoleToCreate"
                    icon="el-icon-fa-file-o"
                    @click="create()"
                    type="primary"
                >{{$t('table.add')}}</el-button>
                <el-button
                    v-if="hasRoleToReadLogs"
                    icon="el-icon-fa-history"
                    @click="history()"
                    type="infor"
                >{{$t('table.history')}}</el-button>
                <el-button
                    v-if="pager.hasDataToExport(list) && hasRoleToReadLogs"
                    @click="pager.exportToCsv(list)"
                    :plain="true"
                    type="success"
                    icon="el-icon-fa-table"
                >{{$t('table.export')}}</el-button>
            </el-col>
        </el-row>
        <!-- ************************** -->
        <!-- *                        * -->
        <!-- *  Players import data   * -->
        <!-- *                        * -->
        <!-- ************************** -->
        <transition name="fade" mode="out-in">
            <router-view name="playerImport"></router-view>
        </transition>


        <el-table
            :data="pager.paginate(list)"
            :default-sort="{
            prop: 'name',
            order: 'ascending'
        }"
            @row-click="rowClick"
            :empty-text="emptyText"
            @sort-change="(args) => pager.sortChange(args)"
            style="width: 100%"
            v-loading="loading"
            border
        >
            <el-table-column prop="name" :label="$t('entities.tournament.prop.name')" sortable="custom"></el-table-column>

            <el-table-column prop="category" :label="$t('entities.tournament.prop.category')" sortable="custom">
                <template
                    slot-scope="scope"
                >{{ scope.row.category ? scope.row.category.label : '' }}</template>
            </el-table-column>
            
            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="locality"
                :label="$t('entities.tournament.prop.locality')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="country"
                :label="$t('entities.tournament.prop.country')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="web"
                :label="$t('entities.tournament.prop.web')"
                sortable="custom"
            ></el-table-column>

            <!-- <el-table-column prop="sizeTeams" :label="$t('entities.player.numberOfPlayers')" sortable="custom">
                <template slot-scope="scope">{{ getSize(scope.row.players) }}</template>
            </el-table-column> -->
            <!-- ************************** -->
            <!-- *                        * -->
            <!-- *         Actions        * -->
            <!-- *                        * -->
            <!-- ************************** -->
                  <el-table-column
        :fixed="isMobile? undefined : 'right'"
        align="center"
        :label="$t('table.actions')"
        width="120"
      >
            <template slot-scope="scope">
                <el-dropdown trigger="click">
                    <el-button class="el-dropdown-link" size="small" round>
                                <i class="el-icon-more"></i>
                    </el-button>
                <el-dropdown-menu slot="dropdown">
                    <!-- SETTING GROUPS -->
                    <el-dropdown-item  v-if="hasRoleToRead">
                    <el-button
                    icon="el-icon-setting"
                    size="small"
                    type="text"
                    @click="setting(scope.row)"
                    >{{$t('table.setting')}}
                    </el-button>
                    </el-dropdown-item>

                    <!-- DETAILS -->
                    <el-dropdown-item  v-if="hasRoleToRead">
                    <el-button
                    icon="el-icon-fa-search"
                    size="small"
                    type="text"
                    @click="show(scope.row.id)"
                    >{{$t('table.details')}}
                    </el-button>
                    </el-dropdown-item>

                    <!-- EDIT -->
                    <el-dropdown-item  v-if="hasRoleToUpdate">
                    <el-button
                        icon="el-icon-fa-pencil-square-o"
                        size="small"
                        type="text"
                        @click="edit(scope.row.id)"
                    >
                    {{$t('table.edit')}}
                    </el-button>
                    </el-dropdown-item>
                    <!-- DESTROY -->
                    <el-dropdown-item  v-if="hasRoleToDelete">
                    <el-button
                    icon="el-icon-fa-trash"
                    size="small"
                    type="text"
                    @click="destroy(scope.row.id)"
                    >
                    {{$t('table.delete')}}
                    </el-button>

                    </el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </template>
            <!-- <el-table-column
                :fixed="isMobile? undefined : 'right'"
                align="center"
                :label="$t('table.actions')"
                width="160"
            >
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="hasRoleToRead"
                        :content="$t('table.details')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-search"
                            size="small"
                            type="text"
                            @click="show(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
                        <el-button
                            icon="el-icon-fa-pencil-square-o"
                            size="small"
                            type="text"
                            @click="edit(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip
                        v-if="hasRoleToDelete"
                        :content="$t('table.delete')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-trash"
                            size="small"
                            type="text"
                            @click="destroy(scope.row)"
                        />
                    </el-tooltip>
                </template> -->
            </el-table-column> 
        </el-table>

        <div class="mt-3">
            <el-pagination
                style="float: right"
                @size-change="(args) => pager.pageSizeChange(args)"
                :current-page.sync="pager.currentPage"
                :layout="paginationLayout"
                :total="pager.filteredAndSortedList(list).length"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "underscore";

/* eslint-disable */
export default {
    name: "app-tournament-list",

    data() {
        return {
            title: "Equipos",
            labels: {
                name: "Nombre",
                category: "Categoría"
            },
            breadcrumbLabels: {
                home: "Inicio",
                tournaments: "Equipos",
                edit: "Editar",
                new: "Nuevo"
            },
            emptyText: "There are no tournaments yet"
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/tournament/loading",
            list: "entities/tournament/list",
            pager: "entities/tournament/pager",
            hasRoleToDelete: "entities/tournament/hasRoleToDelete",
            hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
            hasRoleToRead: "entities/tournament/hasRoleToRead",
            hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
            hasRoleToCreate: "entities/tournament/hasRoleToCreate",
            isMobile: "shared/isMobile",
            paginationLayout: "shared/paginationLayout"
        })
    },

    created() {
        this.$store.dispatch("entities/tournament/list");
    },

    beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        this.$store.dispatch("entities/tournament/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/tournament/list");
        next();
    },

    methods: {
        create() {
            this.$router.push({
                name: "tournamentNew"
            });
        },

        rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "tournamentShow",
                    params: { id: row.id }
                });
            }
        },

        setting(tournament) {
            this.$router.push({
                name: "tournamentSettings",
                params: { id: tournament.id }
            });
        },

        exportTeamAsPdf(tournament) {
           this.$store
                    .dispatch("entities/tournament/exportAsPDF", tournament)
                  
        },

        show(id) {
            console.log("*******");
            console.log(id);

            this.$router.push({
                name: "tournamentShow",
                params: { id }
            });
        },

        edit(id) {
            this.$router.push({
                name: "tournamentEdit",
                params: { id }
            });
        },

        destroy(model) {
            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning',
            })
            .then(() =>
                this.$store
                    .dispatch("entities/tournament/destroy", model)
                    .then(() => {
                        this.$store.dispatch("entities/tournament/list");
                    })
            )
            .catch(() => {});
        },

        history() {
            this.$router.push({ name: "tournamentHistoryFull" });
        },

        // Auz functions

        getSize(obj) {
            return _.size(obj);
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/tournament/tournament-list.vue?5cccc59c